"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = require("prop-types");
var _styledComponents = require("styled-components");
var _dsIcons = require("@olxbr/ds-icons");
var _utils = require("./helper/utils");
var _style = require("./style");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n["default"] = e, t && t.set(e, n), n;
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var Slider = /*#__PURE__*/function (_PureComponent) {
  function Slider(props) {
    var _this;
    _classCallCheck(this, Slider);
    _this = _callSuper(this, Slider, [props]);
    _defineProperty(_this, "state", {
      showArrowLeft: false,
      showArrowRight: false
    });
    _defineProperty(_this, "messagesScroller", null);
    _defineProperty(_this, "handleScroll", function () {
      var isToLeft = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      _this.messagePosition += isToLeft ? -1 : 1;
      var maxAnimationSize = (0, _utils.getMaxAnimationSize)(_this.messagesScroller, _this.marginSize);
      var animationPosition = (0, _utils.getFinalPosition)(_this.messagesScroller, _this.marginSize, _this.sizeWhenLeftArrowAppears, _this.messagePosition);
      _this.setState({
        showArrowLeft: (0, _utils.shouldShowLeftArrow)(animationPosition),
        showArrowRight: (0, _utils.shouldShowRightArrow)(animationPosition, maxAnimationSize),
        animationPosition: -animationPosition
      });
    });
    _defineProperty(_this, "handleRef", function (ref) {
      _this.messagesScroller = ref;
    });
    var numberParser = props.theme.util.numberParser;
    Object.assign(_this, {
      messagePosition: 0,
      marginSize: props.marginSize,
      sizeWhenLeftArrowAppears: numberParser('sizeWhenLeftArrowAppears')
    });
    return _this;
  }
  _inherits(Slider, _PureComponent);
  return _createClass(Slider, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.calculateArrowsShow();
    }
  }, {
    key: "calculateArrowsShow",
    value: function calculateArrowsShow() {
      var maxAnimationSize = (0, _utils.getMaxAnimationSize)(this.messagesScroller, this.marginSize);
      var animationPosition = 0;
      this.setState({
        showArrowLeft: (0, _utils.shouldShowLeftArrow)(animationPosition),
        showArrowRight: (0, _utils.shouldShowRightArrow)(animationPosition, maxAnimationSize)
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var children = this.props.children;
      var _this$state = this.state,
        showArrowLeft = _this$state.showArrowLeft,
        showArrowRight = _this$state.showArrowRight,
        animationPosition = _this$state.animationPosition;
      return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_style.Container, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_style.ItensContainer, {
          animationPosition: animationPosition,
          ref: this.handleRef,
          children: children
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_style.LeftDiv, {
          onClick: function onClick() {
            return _this2.handleScroll(true);
          },
          show: showArrowLeft,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_dsIcons.ChevronLeft, {})
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_style.RightDiv, {
          onClick: function onClick() {
            return _this2.handleScroll();
          },
          show: showArrowRight,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_dsIcons.ChevronRight, {})
        })]
      });
    }
  }]);
}(_react.PureComponent);
_defineProperty(Slider, "propTypes", {
  children: (0, _propTypes.oneOfType)([_propTypes.array, _propTypes.element]).isRequired,
  theme: _propTypes.object.isRequired,
  marginSize: _propTypes.number.isRequired
});
var _default = exports["default"] = (0, _styledComponents.withTheme)(Slider);